import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import ChatApp from "./chat";

const Applications = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      {/* Route with optional userId query parameter */}
      <Route exact path={`${match.url}/`} component={ChatApp} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default Applications;
